import { render, staticRenderFns } from "./LegalDocumentContent_4bwrIQ.vue?vue&type=template&id=e1be9afc&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_4bwrIQ.vue?vue&type=style&index=0&id=e1be9afc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1be9afc",
  null
  
)

export default component.exports